import React, { useEffect, useState } from "react";
import { Box, Typography, Button, Stack, useTheme } from "@mui/material";
import BackButton from "../../../components/BackButton";
import LabelTxtFieldInfo from "../../../components/LabelTxtFieldInfo";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuthContext } from "../../../context/AuthContext";
import route from "../../../utils/Routes";
import { customAlert, notify } from "../../../components/notify";
import BgBoxOld from "../../../components/BgBoxOld";
import { useQuery, useQueryClient } from "react-query";
import QueryKey from "../../../utils/QueryKey";
import { datePickerformat, isNotEmpty } from "../../../utils/format";
import { editPoProdTrackServ, getSinglePoProdServ } from "../../../services/po-service";
import CtrlCustomDropDown from "../../../components/CtrlCustomDropDown";


const prodStatusArr = [
    { value: "awaiting_post_po_clarify", label: "AWAITING POST-PO CLARIFICATION" },
    { value: "packing_in_prog", label: "PACKING IN PROGRESS" },
    { value: "material_ready", label: "MATERIAL IS READY" },
    { value: "awaiting_sdo_dhl_pickup", label: "AWAITING SDO/DHL PICK-UP" },
    { value: "back_order", label: "BACK ORDER" },
    { value: "partially_del", label: "PARTIALLY DELIVERED" },
    { value: "del_completed", label: "DELIVERY COMPLETED" }];

const paidArr = [
    { value: "1", label: "YES" },
    { value: "0", label: "NO" }];

function EditPoProdTrackDetails() {
    const queryClient = useQueryClient();
    const theme = useTheme();
    const location = useLocation();
    const navigate = useNavigate();
    const { poProdId, comId } = location.state || {};
    const { setLoadingScreen } = useAuthContext();
    const [selection, setSelection] = useState({ prodStatus: "", isPaid: "" });
    const [formErrors, setFormErrors] = useState({});

    const { isLoading, isError, error, data: poProdData } = useQuery([QueryKey.poProdInfo, poProdId],
        () => getSinglePoProdServ(poProdId),
        {
            enabled: isNotEmpty(poProdId),
            refetchOnMount: true,
            refetchOnWindowFocus: false,
        });


    useEffect(() => {
        if (!poProdId)
            navigate("/", { replace: true })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [poProdId])


    useEffect(() => {
        if (!poProdData)
            return
        setSelection({ prodStatus: poProdData?.prodStatus, isPaid: poProdData?.isPaid })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [poProdData])

    useEffect(() => {
        setLoadingScreen(false);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isLoading]);



    async function handleSubmit(e) {
        e.preventDefault();
        const formData = new FormData(e.target);
        const inputObject = Object.fromEntries(formData); // convert the FormData object to a JSON object
        let errorsObj = validate(inputObject);
        setFormErrors(errorsObj);
        if (Object.keys(errorsObj).length > 0)
            return;

        setLoadingScreen(true);
        try {
            // poProdId, prodStatus, isPaid, expecDelDate, estTimeArr, amtcRemarks
            const payload = {
                poProdId: poProdId,
                amtcRemarks: inputObject.amtcRemarks,
                prodStatus: selection.prodStatus,
                isPaid: isNotEmpty(selection.isPaid) ? selection.isPaid : null,
                expecDelDate: isNotEmpty(inputObject.expecDelDate) ? inputObject.expecDelDate : null,
                estTimeArr: isNotEmpty(inputObject.estTimeArr) ? inputObject.estTimeArr : null,
            }
            console.dir(payload);
            const { message } = await editPoProdTrackServ(payload);
            notify("success", message);
            queryClient.invalidateQueries();
            navigate(-1, { replace: true })
        } catch (error) {
            console.log(error)
            customAlert(error)
        }
        setLoadingScreen(false);
    };


    function validate(values) {
        const errors = {};
        // if (!values.catName)
        //     errors.catName = "Category Name is required!";

        return errors;
    };



    function handleCancel() {
        navigate(-1)
    }

    function handleDDChange(e) {
        const { name, value } = e.target;
        setSelection((e) => { return { ...e, [name]: value } });
    }


    if (isError) {
        customAlert(error);
        return <h2>Something went wrong</h2>
    }


    return (
        <form onSubmit={handleSubmit} noValidate id='addPo' style={{ padding: 0, height: "100%", width: "100%" }}>
            <Stack direction={"row"} alignItems={'center'} justifyContent={'space-between'} mb={1} mt={0.5}>
                <BackButton />
                <Typography sx={{ fontSize: 18, fontWeight: 500 }}>Update PO Product Details </Typography>
                <Box />
            </Stack>
            <BgBoxOld height={"93%"} py={1}>
                {poProdData && <Stack direction={"row"} height={"100%"} gap={6} mt={1} sx={{ position: "relative" }}>
                    <Stack gap={1} width={"100vw"}>
                        <Stack gap={2}>
                            <Stack direction={"row"} alignItems={"center"} gap={8}>
                                <LabelTxtFieldInfo name="poIdStrg" defaultValue={poProdData?.poIdStrg} readOnly={true} title="PO NUMBER" bgColor={"rgba(162, 214, 249, 0.18)"} width={250} height={30} borderRadius={1} rows={1} />
                                <LabelTxtFieldInfo name="comProdIdStrg" defaultValue={poProdData?.comProdIdStrg} readOnly={true} title="MATERIAL CODE" bgColor={"rgba(162, 214, 249, 0.18)"} width={250} height={30} borderRadius={1} rows={1} />
                                <LabelTxtFieldInfo name="prodName" defaultValue={poProdData?.prodName} readOnly={true} title="DESCRIPTION" bgColor={"rgba(162, 214, 249, 0.18)"} width={250} height={30} borderRadius={1} rows={1} />
                            </Stack>
                            <Stack direction={"row"} alignItems={"center"} gap={8}>
                                <LabelTxtFieldInfo name="expecDelDate" type='date' defaultValue={datePickerformat(poProdData?.expecDelDate)} errMsg={formErrors.expecDelDate} title="ETD" width={250} height={30} borderRadius={1} rows={1} />
                                <LabelTxtFieldInfo name="estTimeArr" type='date' defaultValue={datePickerformat(poProdData?.estTimeArr)} errMsg={formErrors.estTimeArr} title="ETA" width={250} height={30} borderRadius={1} rows={1} />
                            </Stack>
                            <Stack direction={"row"} alignItems={"center"} gap={8} >
                                <CtrlCustomDropDown name="prodStatus" errMsg={formErrors.prodStatus} title={"Status"} width={250} height={30} borderRadius={1}
                                    handleDDChange={handleDDChange} ddArr={prodStatusArr} value={selection.prodStatus} />
                                <CtrlCustomDropDown name="isPaid" errMsg={formErrors.isPaid} title={"PAYMENT STATUS"} width={250} height={30} borderRadius={1}
                                    handleDDChange={handleDDChange} ddArr={paidArr} value={selection.isPaid} />
                            </Stack>
                            <LabelTxtFieldInfo name="amtcRemarks" defaultValue={poProdData?.amtcRemarks} title="AMTC Remarks" borderRadius={1}
                                width={565} rows={4} multiline={true} height={100} />
                        </Stack>

                        <Stack width={"60%"} alignItems={"end"} mt={4}>
                            <Stack direction={"row"} alignItems={"center"}>
                                <Button variant="outlined" onClick={handleCancel} sx={{
                                    fontWeight: 600, height: 40, width: 100, borderRadius: 2, backgroundColor: theme.palette.custom.grey,
                                    color: theme.palette.custom.btn, mr: 2,
                                }}>CANCEL</Button>
                                <Button variant="contained" type="submit"
                                    sx={{ fontWeight: 600, height: 40, width: 100, bgcolor: theme.palette.custom.btn, color: "white", }}>SAVE</Button>
                            </Stack>
                        </Stack>
                    </Stack>

                </Stack>}
            </BgBoxOld>
        </form>
    );
};

export default EditPoProdTrackDetails;